import {assert} from 'Asserts';
import {TYPENAME_MAPPING_FILENAME} from 'graphql-client/APIIDPrefixToTypename';
import {getAPIIDPrefix} from 'util/APIUtil';
import {Optional} from 'util/Types';

type ApiIdPrefixToTypenameMapping = Record<string, string>;

// Primarily exported for Declarative Translations internal use - prefer getTypenameFromID
export function maybeGetTypenameFromID(
  apiIdPrefixToTypename: ApiIdPrefixToTypenameMapping,
  nullableRESTID: Optional<string | number>
): string | null {
  if (typeof nullableRESTID !== 'string') {
    return null;
  }

  const prefix = getAPIIDPrefix(nullableRESTID);
  if (!prefix) {
    return null;
  }

  return apiIdPrefixToTypename[prefix] ?? null;
}

export default function getTypenameFromID(
  apiIdPrefixToTypename: ApiIdPrefixToTypenameMapping,
  nullableRESTID: Optional<string | number>
): string {
  const typename = maybeGetTypenameFromID(apiIdPrefixToTypename, nullableRESTID);
  assert(
    typename != null,
    `Could not compute typename for restObj with ID ${nullableRESTID} - consider adding a record to ${TYPENAME_MAPPING_FILENAME}`
  );
  return typename;
}
